export default "__VITE_ASSET__Cxft1SfJ__"